import classNames from 'classnames'
import { checkIfValueNotEmpty } from 'legacy/lut/helpers/checkIfValueNotEmpty'
import React from 'react'

import { Button, IButtonProps } from 'core-components/library/button'
import { IInputProps, INumberProps } from 'core-components/library/inputs'
import { isValidEmail, IValidateInputProps } from 'core-components/library/validation'
import { VisualAudienceExtended } from 'core/components/shared/ui/VisualAudienceExtended'
import {
  OnboardingInput,
  OnboardingNumberInput,
  OnboardingValidateInput,
} from 'onboarding/components/ui/theme'

import styles from '../PartnerShipNA.module.scss'

import { MAX_PERCENT, MIN_PERCENT } from './constants'
import { IBusinessOwner } from './types'

interface IProps {
  onChange: (value: IBusinessOwner[]) => void
  businessOwners: IBusinessOwner[]
  writeAudience: IObjectAny
  disabled?: boolean
}

const checkEmailIfNotEmpty = (value: string) => checkIfValueNotEmpty(isValidEmail)(value)

export const BusinessOwnerNa = ({ onChange, businessOwners, writeAudience, disabled }: IProps) => {
  const onLocalChange = (field: string, value: string | number, index: number) => {
    businessOwners[index] = { ...businessOwners[index], [field]: value }
    onChange(businessOwners)
  }

  const renderItem = (item: IBusinessOwner, index: number) => {
    return (
      <div
        className={classNames(styles.businessOwnerItemContainer, styles.businessOwnerItemWrapper)}
        key={`${item.FirstName}_${item.LastName}_${index}`}
      >
        <VisualAudienceExtended<IInputProps>
          component={OnboardingInput}
          write={writeAudience}
          label={`First Name`}
          value={item.FirstName || ''}
          onChange={(value: string) => onLocalChange('FirstName', value, index)}
          disabled={disabled}
        />
        <VisualAudienceExtended<IInputProps>
          component={OnboardingInput}
          write={writeAudience}
          label={`Last Name`}
          value={item.LastName || ''}
          onChange={(value: string) => onLocalChange('LastName', value, index)}
          disabled={disabled}
          classes={{
            root: styles.businessOwnerItemInputWrapper,
          }}
        />
        <VisualAudienceExtended<IInputProps>
          component={OnboardingInput}
          write={writeAudience}
          label={'Job Title'}
          value={item.JobTitle || ''}
          onChange={(value: string) => onLocalChange('JobTitle', value, index)}
          disabled={disabled}
          classes={{
            root: styles.businessOwnerItemInputWrapper,
          }}
        />
        <VisualAudienceExtended<IValidateInputProps>
          component={OnboardingValidateInput}
          write={writeAudience}
          label={`Email`}
          value={item.Email || ''}
          onChange={(value: string) => onLocalChange('Email', value, index)}
          checkFn={checkEmailIfNotEmpty}
          disabled={disabled}
          classes={{
            validatorClasses: {
              root: styles.businessOwnerItemInputWrapper,
            },
          }}
        />
        <div className={styles.root__delete}>
          <VisualAudienceExtended<INumberProps>
            component={OnboardingNumberInput}
            write={writeAudience}
            label={`Ownership (%)`}
            value={item.Ownership ?? undefined}
            min={MIN_PERCENT}
            max={MAX_PERCENT}
            onChange={(value: string) => onLocalChange('Ownership', Number(value), index)}
            disabled={disabled}
            classes={{
              root: classNames(
                styles.businessOwnerItemInputWrapper,
                styles.businessOwnerItemNumber
              ),
            }}
          />
          {businessOwners.length > 1 && (
            <VisualAudienceExtended<IButtonProps>
              write={writeAudience}
              component={Button}
              variant={'text'}
              color={'danger'}
              onClick={() => onChange(businessOwners.filter((item, id) => id !== index))}
              disabled={disabled}
              className={styles.businessOwnerItemInputWrapper}
            >
              X
            </VisualAudienceExtended>
          )}
        </div>
      </div>
    )
  }
  return (
    <div>
      <div className={styles.text__title}>
        Business Owner{' '}
        <div className={styles.text__rule}>
          {'(Applies to T1 & T2 Reseller and T1 Distributor)'}
        </div>
      </div>
      {businessOwners.map((item, index) => renderItem(item, index))}
      <VisualAudienceExtended<IButtonProps>
        write={writeAudience}
        component={Button}
        variant={'text'}
        iconButton={'kbase kbase-add'}
        onClick={() => {
          businessOwners.push({} as IBusinessOwner)
          onChange([...businessOwners])
        }}
        disabled={disabled}
        className={styles.businessOwnerItemWrapper}
      />
    </div>
  )
}
